import Buttons from "../../../../components/Button/button.component";
import { colors } from "../../../../theme/color";
import UserManagementHeader from "../../UserManagementHeader";
import UserTextHeader from "../../UserManagementHeader/UserTextHeader";
import TwoFactAuth from "./TwoFactAuthModal";
import {
  AccountSecSection,
  AccountSecSectionActivate,
  AccountSecSectionButtoCon,
  AccountSecSectionSubTitle,
  AccountSecSectionTitle,
  AccountSectButton,
  AccountSectButton1,
  AccountSettingBody,
  AccountSettingHeaderText,
  AccountSettingMain,
  AccountSettingMainHeader,
  AccountSettinsss,
  Status,
  TitleWrap,
  TwoAuthMainTitle,
  TwoAuthSubTitle,
  TwoAuthTitleHead,
} from "./AccountSettings.styles";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import {
  activateOrDeactivate2FA,
  verify2FA,
} from "../../../../graphql/mutations/userManagement";
import { setLoading } from "../../../../store/loadingSpinner";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";
import VerifyNumOtpModal from "./VerifyNumberModal";
import { toast } from "react-toastify";
import { get2FAStatusById } from "../../../../graphql/queries/userManagement";

const AccountSettings = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showModalWrapper, setShowModalWrapper] = useState(false);
  const [enable2FA, setEnable2FA] = useState(false);
  const [activateOrDeactivate2FAMutation] = useMutation(
    activateOrDeactivate2FA
  );
  const [verify2FAMutation] = useMutation(verify2FA);
  const { phone, otp } = useSelector((state: RootState) => state.user?.user);
  const { loading, data, refetch: refetchStatus } = useQuery(get2FAStatusById);
  const twoFactorAuth = data?.get2FAStatusById?.success;

  const dispatch = useDispatch();

  const openModal = () => {
    setIsModalOpen(true);
  };
  const openOtpModal = () => {
    setShowModalWrapper(true);
    handleSubmit();
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handleSubmit = async () => {
    dispatch(setLoading(true));
    try {
      const response = await activateOrDeactivate2FAMutation({
        variables: {
          phone: phone,
        },
      });

      if (response.data.activateOrDeactivate2FA.otpSent) {
        setIsModalOpen(false);
        setShowModalWrapper(true);
      } else {
      }
    } catch (error) {
      console.error("Error confirming phone number:", error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleVerify2FA = async () => {
    setShowModalWrapper(false);
    dispatch(setLoading(true));
    try {
      const response = await verify2FAMutation({
        variables: {
          otp: otp.join(""),
        },
      });

      if (response.data.verify2FA.success) {
        if (enable2FA) {
          toast.success("You've successfully deactivated your 2FA");
          setEnable2FA(false);
          refetchStatus();
        } else {
          toast.success("You've successfully activated your 2FA");
          setEnable2FA(true);
          refetchStatus();
        }
      }
    } catch (error) {
      console.error("Failed to verify 2FA:", error);
    } finally {
      dispatch(setLoading(false));
    }
  };
  const toggleVerifyModal = () => {
    setShowModalWrapper(!showModalWrapper);
  };

  useEffect(() => {
    if (data) {
      setEnable2FA(twoFactorAuth);
    }
  }, [data, enable2FA]);

  return (
    <div>
      <UserTextHeader />
      <UserManagementHeader />
      <div style={{ width: "77vw", paddingLeft: "20px" }}>
        <AccountSettingMain>
          <AccountSettingMainHeader>
            <AccountSettingHeaderText>
              Account Settings
            </AccountSettingHeaderText>
          </AccountSettingMainHeader>
          <AccountSettinsss>
            <AccountSettingBody>
              <TwoAuthTitleHead>
                <TwoAuthMainTitle>Two-factor Authentication</TwoAuthMainTitle>
                <TwoAuthSubTitle>
                  Keep your account secure. We recommend that you enable various
                  kinds of two-step authentication as a backup incase you lose
                  your mobile device or service.
                </TwoAuthSubTitle>
              </TwoAuthTitleHead>
              <AccountSecSection>
                <div>
                  <TitleWrap>
                    <AccountSecSectionTitle>Use SMS</AccountSecSectionTitle>
                    {enable2FA ? <Status>Enabled</Status> : ""}
                  </TitleWrap>
                  <AccountSecSectionSubTitle>
                    You’ll receive a one-time code via SMS for users account
                  </AccountSecSectionSubTitle>

                  <div
                    style={{ display: "flex", cursor: "pointer" }}
                    onClick={enable2FA ? openOtpModal : openModal}
                  >
                    <AccountSecSectionActivate $deactivate={enable2FA}>
                      {enable2FA ? "Deactivate" : "Activate"}
                    </AccountSecSectionActivate>
                    {enable2FA ? (
                      <img src="/assets/svg/arrow-right-red.svg" />
                    ) : (
                      <img src="/assets/svg/arrow-right.svg" />
                    )}
                  </div>
                </div>
                <div style={{ margin: "0px" }}>
                  <div>
                    <AccountSecSectionTitle>
                      Add a security Key
                    </AccountSecSectionTitle>
                    <AccountSecSectionSubTitle>
                      Use a small USB key to provide an additional layer of
                      security for users account
                    </AccountSecSectionSubTitle>
                  </div>
                  <div style={{ display: "flex", cursor: "pointer" }}>
                    <AccountSecSectionActivate>
                      Activate
                    </AccountSecSectionActivate>{" "}
                    <img src="/assets/svg/arrow-right.svg" />
                  </div>
                </div>

                <AccountSecSectionButtoCon>
                  <AccountSectButton>
                    <Buttons
                      label="Cancel"
                      cursor="pointer"
                      border="10px"
                      width="100%"
                      height="50px"
                      borderLine="1px solid #AFAFAF"
                      color={colors.White}
                      textColor={colors.NEUTRAL_GREY}
                      style={{
                        width: "70%",
                        height: "44px",
                        borderRadius: "10px",
                        border: "1px solid #AFAFAF",
                        color: "#AFAFAF",
                        backgroundColor: "white",
                      }}
                    />
                  </AccountSectButton>
                  <AccountSectButton1>
                    <Buttons
                      label="Save Changes"
                      width="100%"
                      height="50px"
                      cursor="pointer"
                      border="10px"
                      color={colors.ButtonBackgroundColors.primaryDefaultButton}
                      // disabled={!isFormValid()}
                      style={{
                        width: "100%",
                        height: "44px",
                        borderRadius: "10px",
                        color: "white",
                        backgroundColor: "#00A603",
                      }}
                    />
                  </AccountSectButton1>
                </AccountSecSectionButtoCon>
              </AccountSecSection>
            </AccountSettingBody>
          </AccountSettinsss>
        </AccountSettingMain>
      </div>
      {isModalOpen && (
        <TwoFactAuth onClose={handleClose} onSubmit={handleSubmit} />
      )}
      {showModalWrapper && (
        <VerifyNumOtpModal
          onClose={toggleVerifyModal}
          onSubmit={handleVerify2FA}
        />
      )}
    </div>
  );
};

export default AccountSettings;
